<template>
	<div class="selector-wrapper">
		<Selector
			v-for="num in level"
			:key="num"
			:value="value[`cate${num}`]"
			:optionList="list[`cate${num}`]"
			class="selector-wrapper__selector"
			@input="cateInput($event, num)"
		/>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import Selector from '@/components/Selector.vue';

	export default {
		name: 'CateSelector',
		components: {
			Selector,
		},
		props: {
			value: {
				type: Object,
				default: () => ({
					cate1: null,
					cate2: null,
					cate3: null,
				}),
			},
			disabled: {
				type: [Array, Boolean],
				default: false,
			},
			level: {
				type: Number,
				default: 3,
			},
		},
		computed: {
			...mapState({
				cate1AllList(state) {
					return this.sortList(state.filter.firstCategories);
				},
				cate2AllList(state) {
					return this.sortList(state.filter.secondCategories);
				},
				cate3AllList(state) {
					return this.sortList(state.filter.thirdCategories);
				},
			}),
			cate1List() {
				return [
					{ value: null, name: '1차 카테고리 선택' },
					...this.cate1AllList
						.filter(item => !item.isDeleted)
						.map(item => ({
							value: item.idFirstCategory,
							name: this.setCateName(
								item.isDisplay,
								item.firstCategoryText
							),
						})),
				];
			},
			cate2List() {
				const defValue = { value: null, name: '2차 카테고리 선택' };
				const cate1 = this.value.cate1;
				return cate1
					? [
							defValue,
							...this.cate2AllList
								.filter(
									item =>
										!item.isDeleted &&
										item.idFirstCategory === cate1
								)
								.map(item => ({
									value: item.idSecondCategory,
									name: this.setCateName(
										item.isDisplay,
										item.secondCategoryText
									),
								})),
						]
					: [defValue];
			},
			cate3List() {
				const defValue = { value: null, name: '3차 카테고리 선택' };
				const cate2 = this.value.cate2;
				return cate2
					? [
							defValue,
							...this.cate3AllList
								.filter(
									item =>
										!item.isDeleted &&
										item.idSecondCategory === cate2
								)
								.map(item => ({
									value: item.idThirdCategory,
									name: this.setCateName(
										item.isDisplay,
										item.thirdCategoryText
									),
								})),
						]
					: [defValue];
			},
			list() {
				return {
					cate1: this.cate1List,
					cate2: this.cate2List,
					cate3: this.cate3List,
				};
			},
		},
		methods: {
			sortList(list) {
				return list.sort((a, b) => a.sortKey - b.sortKey);
			},
			setCateName(isDisplay, name) {
				return isDisplay ? name : `[미노출] ${name}`;
			},
			cateInput(value, num) {
				const payload = {
					cate1: null,
					cate2: null,
					cate3: null,
				};
				if (num === 1) {
					payload.cate1 = value;
				} else if (num === 2) {
					payload.cate1 = this.value.cate1;
					payload.cate2 = value;
				} else if (num === 3) {
					payload.cate1 = this.value.cate1;
					payload.cate2 = this.value.cate2;
					payload.cate3 = value;
				}
				this.$emit('input', payload);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.selector-wrapper {
		display: flex;

		&__selector {
			margin: 6px 6px 0 0;
		}
	}
</style>
